import { render, staticRenderFns } from "./RouterLink_Overlay.vue?vue&type=template&id=172c3e51&"
import script from "./RouterLink_Overlay.vue?vue&type=script&lang=js&"
export * from "./RouterLink_Overlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports